import { zodResolver } from '@hookform/resolvers/zod'
import { type FieldValues, type UseFormProps as UseFormHookProps, useForm as useFormHook } from 'react-hook-form'
import { type ZodType } from 'zod'

type UseFormProps<TFieldValues extends FieldValues = FieldValues, TContext = unknown> = Omit<UseFormHookProps<TFieldValues, TContext>, 'resolver'> & {
  validationSchema: ZodType<TFieldValues>
}

export const useForm = <TFieldValues extends FieldValues = FieldValues, TContext = unknown>(props: UseFormProps<TFieldValues, TContext>) => {
  const methods = useFormHook<TFieldValues>({
    mode: 'onBlur',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(props.validationSchema as any),
    ...props,
  })

  return {
    ...methods,
    validationSchema: props.validationSchema,
  }
}

export type UseFormReturn<TFieldValues extends FieldValues = FieldValues, TContext = unknown> = ReturnType<typeof useForm<TFieldValues, TContext>>
